var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"value":_vm.notification.showing,"center":"","shaped":"","top":"","color":_vm.notification.color}},[_c('div',{staticClass:"text-center"},[_c('v-icon',{staticClass:"pr-2"},[_vm._v(_vm._s(_vm.notification.icon))]),_vm._v(_vm._s(this.notification.message)+" ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }